// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3al2d","title":"Info_title__2oey3","links":"Info_links__3zm53","link":"Info_link__3ExGg","logo":"Info_logo__uIKj6"};